import { Standort } from '@/domain/mitarbeiter/features/rotationsplan/entities/Standort';
import { View } from '@/domain/mitarbeiter/features/rotationsplan/entities/views';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import { FilterCombobox } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/FilterCombobox';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function StandorteFilter({ view }: { view: View }) {
  const { t } = useTranslation();
  const { currentStandort } = useStandortContext();
  const { store, updateFetchStandorte } = useRotationsplanFeatureContext();
  const {
    data: { standorte },
    ui: {
      kalender: {
        filter: { standorte: kalenderFilter },
      },
      uebersicht: {
        filter: { standorte: uebersichtFilter },
      },
    },
  } = store;
  const [selectedStandorte, setSelectedStandorte] = useState<Standort[]>(
    view === 'planung' ? kalenderFilter : uebersichtFilter,
  );
  const currentStandortFilterOption = standorte.find(
    (standort) => standort.id === currentStandort.uid,
  );

  const options = [...standorte]
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((standort) => ({
      value: standort.id,
      label: standort.name,
    }));

  function applySelection(newStandorte: Standort[]) {
    setSelectedStandorte(newStandorte);
    if (view === 'planung') {
      store.setKalenderStandortFilter(newStandorte);
    } else {
      store.setUebersichtStandortFilter(newStandorte);
    }
    const otherViewSelection =
      view === 'planung' ? uebersichtFilter : kalenderFilter;
    updateFetchStandorte([
      ...new Set([...newStandorte, ...otherViewSelection].map((s) => s.id)),
    ]);
  }

  // Ohne Auswahl wird auf den aktuellen Standort zurückgesetzt
  function deselectAll() {
    applySelection(
      currentStandortFilterOption ? [currentStandortFilterOption] : [],
    );
  }

  return (
    <FilterCombobox
      label={t('domain.mitarbeiter.rotationsplan.filter.standort')}
      options={options}
      value={selectedStandorte.map((standort) => standort.id)}
      onValueChange={(values) =>
        values.length > 0
          ? applySelection(
              standorte.filter((standort) => values.includes(standort.id)),
            )
          : deselectAll()
      }
      onClear={deselectAll}
    />
  );
}
